import React from 'react'
import { DecimalInput } from './style'

const Decimal = ({ ...props }) => (
  <DecimalInput decimalSeparator={','} thousandSeparator={'.'} decimalScale={2} fixedDecimalScale={true} {...props} />
)

export default Decimal
